import styled from "@emotion/styled";

export const ResetPasswordPageContainer = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #a3c3f2;
`;